import { Form, Image, Typography, TimePicker } from 'antd'
import DatePickerIcon from '../../assets/icons/datepicker-calendar.svg'
import './CustomTimePicker.scss'

const { Text } = Typography;

const CustomTimePicker = ({ label, name, rules, placeholder, isRequired, ...rest }) => {
    return (
        <Form.Item
            label={label &&
                <Text>
                    {label}
                    {isRequired && <Text type="danger"> *</Text>}
                </Text>
            }
            name={name}
            rules={rules}
            className="custom-time-picker-form-item"
        >
            <TimePicker
                format="hh:mm A"
                placeholder={placeholder}
                className='custom-time-picker'
                suffixIcon={<Image src={DatePickerIcon} preview={false} />}
                {...rest}
            />
        </Form.Item>
    )
}

export default CustomTimePicker